import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const { fallback, section } = this.props;
      
      if (fallback) return fallback;

      return (
        <div className="flex flex-col items-center justify-center p-6 bg-slate-50 rounded-lg border border-slate-200 min-h-[120px]" data-testid="error-boundary">
          <AlertTriangle className="w-8 h-8 text-amber-500 mb-3" />
          <p className="text-sm text-slate-600 mb-1 font-medium">
            {section ? `Erreur dans ${section}` : 'Une erreur est survenue'}
          </p>
          <p className="text-xs text-slate-400 mb-3">Ce module a rencontre un probleme</p>
          <Button variant="outline" size="sm" onClick={this.handleRetry} data-testid="error-retry-btn">
            <RefreshCw className="w-3 h-3 mr-1" />
            Reessayer
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
